import React, { useState, useEffect } from 'react'
import compose from 'recompose/compose'
import { withI18n } from '../../hocs'
import { ModalStyled } from './styled'
import ActionDialog from '../action-dialog'
import { InputField, InfoChip } from '../../atoms'
import { tokens } from '../../../assets/tokens'

const ModalDeletePhase = ({ open, handleClose, i18n, onSubmitDelete, itemId, initialValue, allPhasesData }) => {
  const phaseName = initialValue

  const [phaseStates, setPhaseStates] = useState([]);

  useEffect(() => {
    if (typeof phaseName === 'string' && phaseName.trim() !== '' && allPhasesData) {
      const selectedPhase = allPhasesData.find(fase => fase.name === phaseName);

      if (selectedPhase) {
        setPhaseStates(selectedPhase.status_candidates || []);
      } else {
        setPhaseStates([]);
      }
    } else {
      setPhaseStates([]);
    }
  }, [phaseName, allPhasesData]);

  // Devuelve la promesa: spinner en Eliminar y el modal se cierra solo cuando la petición va bien
  const onClickDelete = e => {
    e.preventDefault();

    return Promise.resolve(onSubmitDelete(itemId)).then(() => handleClose())
  }

  return (
    <ActionDialog
      open={open}
      title={i18n.phases_states.modalDeletePhaseTitle}
      onClose={handleClose}
      onConfirm={onClickDelete}
      cancelLabel={i18n.phases_states.buttonCancel}
      confirmLabel={i18n.phases_states.buttonDelete}
      confirmColor="error"
      maxWidth="sm"
      fullWidth
    >
      <ModalStyled>
        <div className="formField">
          <label>{i18n.phases_states.labelPhase}</label>
          <InputField placeholder={i18n.phases_states.placeholderPhase} value={phaseName} disabled />
        </div>
        <div className="formField">
          <label>{i18n.phases_states.titleState}</label>
          <div className="wrapper-tags">
            {phaseStates.length > 0 ? (
              phaseStates.map((status) => (
                <InfoChip
                  key={status.id}
                  label={status.name}
                  fillColor={status.color || undefined}
                  textColor={status.color ? tokens.color.text.onDark : undefined}
                />
              ))
            ) : (
              <InfoChip label={i18n.phases_states.chipUnAssigned} />
            )}
          </div>
        </div>
      </ModalStyled>
    </ActionDialog>
  )
}

const enhance = compose(withI18n)

export default enhance(ModalDeletePhase)
